document.addEventListener('DOMContentLoaded', () => {
  const zodiacLinks = document.querySelectorAll('.zodiac-item[href^="#"]');

  zodiacLinks.forEach(link => {
    link.addEventListener('click', e => {
      const targetId = link.getAttribute('href');
      const targetEl = document.querySelector(targetId);

      if (!targetEl) return;

      e.preventDefault();

      targetEl.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

      // Update URL hash without jump
      history.pushState(null, '', targetId);
    });
  });
});
